// export const API_URL = "http://127.0.0.1:2004";
// export const API_URL = `${window.location.origin}/api`;
export const API_URL = `${window.location.origin}/api`;
